/**
 * DateRangeFilter Component
 * Date range filter with optional preset buttons and from/to inputs
 */

import React, { useState } from 'react';

const PRESETS = [
  { label: 'Last 7 days', days: 7 },
  { label: 'Last 30 days', days: 30 },
];

const isPresetActive = (from, to, days) => {
  const toDate = new Date();
  const fromDate = new Date();
  fromDate.setDate(fromDate.getDate() - days);
  return from === fromDate.toISOString().split('T')[0] && to === toDate.toISOString().split('T')[0];
};

const DateRangeFilter = ({ from, to, onChange, showPresets = false }) => {
  const [customOpen, setCustomOpen] = useState(false);

  const applyPreset = (days) => {
    const toDate = new Date();
    const fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - days);
    setCustomOpen(false);
    onChange({
      from: fromDate.toISOString().split('T')[0],
      to: toDate.toISOString().split('T')[0],
    });
  };

  const handleFromChange = (e) => {
    onChange({ from: e.target.value, to });
  };

  const handleToChange = (e) => {
    onChange({ from, to: e.target.value });
  };

  const noPresetActive = showPresets && !PRESETS.some(p => isPresetActive(from, to, p.days));
  const showDateInputs = !showPresets || customOpen || noPresetActive;

  return (
    <div className="flex items-center space-x-2">
      {showPresets && PRESETS.map(p => {
        const active = isPresetActive(from, to, p.days);
        return (
          <button
            key={p.days}
            onClick={() => applyPreset(p.days)}
            className={`text-xs px-2.5 py-1.5 rounded-md border transition-colors ${
              active
                ? 'bg-primary-50 border-primary-300 text-primary-700 font-medium'
                : 'border-gray-200 text-gray-600 hover:bg-gray-50'
            }`}
          >
            {p.label}
          </button>
        );
      })}
      {showPresets && (
        <button
          onClick={() => setCustomOpen(!customOpen)}
          className={`text-xs px-2.5 py-1.5 rounded-md border transition-colors ${
            noPresetActive || customOpen
              ? 'bg-primary-50 border-primary-300 text-primary-700 font-medium'
              : 'border-gray-200 text-gray-600 hover:bg-gray-50'
          }`}
        >
          Custom
        </button>
      )}
      {showDateInputs && (
        <>
          <div className="flex items-center space-x-2">
            <label className="text-sm text-gray-500">From</label>
            <input
              type="date"
              value={from}
              onChange={handleFromChange}
              className="input text-sm py-1.5 w-auto"
            />
          </div>
          <div className="flex items-center space-x-2">
            <label className="text-sm text-gray-500">To</label>
            <input
              type="date"
              value={to}
              onChange={handleToChange}
              className="input text-sm py-1.5 w-auto"
            />
          </div>
        </>
      )}
    </div>
  );
};

export default React.memo(DateRangeFilter);
